export const language = {
	english: "abcdefghijklmnopqrstuvwzyz",
	// 魚編の漢字
	fish: "鯵鮎鯇鮑魦鯔鯆鮇鰻鰕魳鰈鮍鱚鯨鯉鯒鮗鮴鮭鯖鮫鰆鯢鯱鮊鯳鯐鮬魛",
	news: '台大校務會議職員代表今年月曾於校務會議上提出臨時動希望監控校園食物的來源檢測廠商管理與罰則防堵萊豬入校園歷經約小時討論後校長管中閔決議交由膳食委員會討論台大今日再度召開校務會議會中由膳食委員會報告校園餐廳豬肉牛肉食品品質管理計畫',
	korean: '박장관은일대검부장회의를통해이사건을재심의하라는수사지휘를내렸다친정권성향검사장이다수포진한현대검부장단만으로회의가열릴경우공정성에문제가있다는지적이나오자조대행은일선고검장까지참석자를확대했다이사건의담당부서인대검감찰부의한동수감찰부장과임은정대검감찰정책연구관은이날회의에참석해기존처럼기소의견을냈지만받아들여지지않았다',
	devanagari: "ऄअआइईउऊऋऌऍऎएऐऑऒओऔकखगघङचछजझञटठडढणतथदधनऩपफबभमयरऱलळऴवशषसह",
}